import React from 'react';
export const Footer = () => {
  return <footer className="bg-ink text-paper/60 py-12 border-t border-paper/10 text-center font-sans text-sm" data-id="element-36">
      <div className="max-w-4xl mx-auto px-6 space-y-4" data-id="element-37">
        <p className="font-serif text-lg text-paper/80 italic" data-id="element-38">
          El Manual del Appointment Setter
        </p>
        <p data-id="element-39">
          Este no es un esquema de enriquecimiento rápido. Los resultados varían
          según el esfuerzo, la constancia y la aplicación del método enseñado.
        </p>
        <p className="pt-4 border-t border-paper/10 text-xs uppercase tracking-widest" data-id="element-40">
          © {new Date().getFullYear()} · Todos los derechos reservados.
        </p>
      </div>
    </footer>;
};